import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField';
import API from '../../../../utils/API';

class DuplicateTicketModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: '',
            description: '',
            startDate: '',
            endDate: '',
            price: 0,
            quantity: 0,
            submitting: false,
            invalid: false,
            success: false,
            requiredFields: {
                label: false,
                description: false,
                startDate: false,
                endDate: false,
                price: false,
                quantity: false
            }
        };
    }

    componentDidMount() {
        const { ticket } = this.props;
        if (ticket) {
            // Format dates if they exist and append "Copy" to the label
            const startDate = ticket.startDate ? new Date(ticket.startDate).toISOString().split('T')[0] : '';
            const endDate = ticket.endDate ? new Date(ticket.endDate).toISOString().split('T')[0] : '';
            
            this.setState({
                label: `${ticket.label} (Copy)`,
                description: ticket.description || '',
                startDate,
                endDate,
                price: ticket.price || 0,
                quantity: ticket.quantity || 0
            });
        }
    }

    submit = () => {
        const { orgId, eventId, flowId } = this.props;
        const { label, description, startDate, endDate, price, quantity } = this.state;

        this.setState({ submitting: true });

        API().post(`Organizations/${orgId}/events/${eventId}/registrationFlows/${flowId}/tickets`, {
            label,
            description,
            startDate,
            endDate,
            price,
            quantity,
        }).then((res) => {
            if (res.data) {
                this.setState({ 
                    success: true,
                    submitting: false
                });
                this.props.onDuplicate(res.data);
            }
        }).catch((err) => {
            this.setState({ 
                submitting: false,
                error: err.response?.data?.message || 'Error duplicating ticket'
            });
            console.error('Error duplicating ticket:', err);
        });
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { 
            label, 
            description, 
            startDate, 
            endDate, 
            price, 
            quantity, 
            submitting, 
            success, 
            requiredFields,
            error
        } = this.state;

        return (
            <div>
                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Duplicate Ticket"}
                    bodyHeaderText="Create a copy of this ticket with modifications if needed."
                    bodyContent={() => {
                        return (
                            <div>
                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}
                                <InputField
                                    label="Ticket Label"
                                    classes={'w-100'}
                                    value={label}
                                    onChange={(e) => this.setState({ label: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.label}
                                    name="label"
                                    type="text"
                                    placeholder="Enter ticket label"
                                />
                                <InputField
                                    label="Ticket Description"
                                    classes={'w-100'}
                                    value={description}
                                    onChange={(e) => this.setState({ description: e.target.value })}
                                    required
                                    errorTrigger={requiredFields.description}
                                    name="description"
                                    type="text"
                                    placeholder="Enter ticket description"
                                />
                                <div className='flex gap10'>
                                    <InputField
                                        label="Start Date"
                                        classes={'w-100'}
                                        value={startDate}
                                        type="date"
                                        onChange={(e) => this.setState({ startDate: e.target.value })}
                                        required
                                        inputIcon={<i className="lar la-calendar" />}
                                        errorTrigger={requiredFields.startDate}
                                        name="startDate"
                                        placeholder="Enter start date"
                                    />
                                    <InputField
                                        label="End Date"
                                        classes={'w-100'}
                                        value={endDate}
                                        type="date"
                                        onChange={(e) => this.setState({ endDate: e.target.value })}
                                        required
                                        inputIcon={<i className="lar la-calendar" />}
                                        errorTrigger={requiredFields.endDate}
                                        name="endDate"
                                        placeholder="Enter end date"
                                    />
                                </div>
                                <div className='flex gap10'>
                                    <InputField
                                        label="Price"
                                        classes={'w-100'}
                                        value={price}
                                        type="number"
                                        onChange={(e) => this.setState({ price: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.price}
                                        name="price"
                                        placeholder="Enter ticket price"
                                    />
                                    <InputField
                                        label="Quantity"
                                        classes={'w-100'}
                                        value={quantity}
                                        type="number"
                                        onChange={(e) => this.setState({ quantity: e.target.value })}
                                        required
                                        errorTrigger={requiredFields.quantity}
                                        name="quantity"
                                        placeholder="Enter ticket quantity"
                                    />
                                </div>
                            </div>
                        )
                    }}
                    toggle={toggle}
                    actionButtonLabel={!success ? !submitting ? 'Create Duplicate' : 'Creating...' : ''}
                    cancelButtonLabel={success ? 'Close' : 'Cancel'}
                    actionButton={() => this.submit()}
                    submitting={submitting}
                    actionButtonDisabled={submitting || success}
                ></FieldModal>
            </div>
        )
    }
}

export default DuplicateTicketModal;
